// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".services-dropdown-title[data-v-7838af18]{color:#435059;font-family:var(--noto-bold);font-size:var(--normalFontSize);border-bottom:1px solid #f7f7f7;padding-top:30px;padding-left:55px;padding-bottom:30px}.services-dropdown[data-v-7838af18]{margin-top:20px}@media screen and (max-width:1023px){.services-dropdown-title[data-v-7838af18]{padding-left:15px}}", ""]);
// Exports
module.exports = exports;
